import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ApiV1Job } from '@bluecrew/crew-member-backend-angular-client';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
  selector: 'app-blueshift-schedule-detail',
  templateUrl: './blueshift-schedule-detail.component.html',
  styleUrls: ['./blueshift-schedule-detail.component.scss'],
})
export class BlueshiftScheduleDetailComponent {

  startDateTime: string;
  endDateTime: string;
  singleShiftDotSvgPath: string = 'assets/icons/schedule-dot.svg';

  @Input() blueshifts: ApiV1Job[];
  @Input()
  get shouldHighlight(): boolean { return this._shouldHighlight; }
  set shouldHighlight(shouldHighlight: boolean) {
    this._shouldHighlight = shouldHighlight
    if (this.shouldHighlight) {
      this.backgroundColor = '#3246F0';
      this.wageColor = '#FFFFFF';
      this.textColor = '#FFFFFF';
      this.border = '1px solid #3246F0'
      this.singleShiftDotSvgPath = 'assets/icons/schedule-dot-white.svg';
      this.badgeBackgroundColor = 'rgba(242, 243, 247, 0.25)';
      this.badgeIcon = 'assets/icons/blueshift-calendar-add-white.svg';
    } else {
      this.backgroundColor = '#FFFFFF';
      this.wageColor = '#3246F0';
      this.textColor = '#080912';
      this.border = '1px solid #BABBC4'
      this.singleShiftDotSvgPath = 'assets/icons/schedule-dot.svg';
      this.badgeBackgroundColor = '#F2F3F7';
      this.badgeIcon = 'assets/icons/blueshift-calendar-add-black.svg';
    }
  }
  private _shouldHighlight: boolean;

  @Input() isSingleSchedule?: boolean = true;
  @Output() selectedJobCardEvent = new EventEmitter<number>();

  wageColor: string = '#3246F0';
  textColor: string = '#080912';
  backgroundColor?: string = '#FFFFFF';
  border: string = '1px solid #BABBC4';
  badgeBackgroundColor?: string = '#F2F3F7';
  badgeIcon?: string = 'assets/icons/blueshift-calendar-add-black.svg';

  constructor() { }

  getMinBlueshiftWage(): number {
    return this.blueshifts.reduce((prev, curr) => prev.wage < curr.wage ? prev : curr).wage;
  }

  getMaxBlueshiftWage(): number {
    return this.blueshifts.reduce((prev, curr) => prev.wage > curr.wage ? prev : curr).wage;
  }

  getWageComponents(wage: number) {
    return wage.toFixed(2).split('.');
  }

  shouldDisplayWageRange(): boolean {
    return this.getMinBlueshiftWage() !== this.getMaxBlueshiftWage();
  }

  getEarliestStartDate() {
    return this.blueshifts.reduce((prev, curr) =>
      dayjs(prev.startTime).isBefore(dayjs(curr.startTime)) ? prev : curr).startTime;
  }

  getLatestStartDate() {
    return this.blueshifts.reduce((prev, curr) =>
      dayjs(prev.startTime).isAfter(dayjs(curr.startTime)) ? prev : curr).startTime;
  }

  shouldDisplayStartDateRange() {
    return !dayjs(this.getEarliestStartDate()).isSame(dayjs(this.getLatestStartDate()), 'day');
  }

}
